import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Chicago required",
      "Ideal for 185th Air Refueling Wing families at Sioux Gateway Airport",
      "Great for Tyson Foods & agribusiness executives traveling internationally",
      "Perfect for Morningside & Briar Cliff students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Sioux City post offices",
      "Good for planned international trips from SUX or OMA",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Woodbury County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "Tri-state mail routing through Des Moines hub adds possible delays",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Iowa, Nebraska, and South Dakota all have zero passport agencies — closest is Chicago (~460 mi, 7+ hr via I-29/I-80)",
      "NPIC appointment required before traveling to Chicago",
      "Life-or-death emergencies only — bereavement or medical crisis documentation required",
      "Winter highway conditions on I-80 and I-29 can make travel unreliable from November–March",
      "Expect to wait all day or return next day at the agency",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function SiouxCityProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Sioux City"
      headingExtra="IA"
      introText="Sioux City travelers — 185th Air Refueling Wing military families at Sioux Gateway Airport, Tyson Foods and agribusiness executives, Morningside and Briar Cliff students studying abroad, and tri-state region (Iowa/Nebraska/South Dakota) residents who are hours from the nearest passport agency — have several options for getting a passport fast. Here is how they compare, and why most choose a U.S. Department of State registered passport courier for predictable processing without the 7+ hour drive to Chicago."
      options={options}
      emergencyDescription="Iowa, Nebraska, and South Dakota all have zero passport agencies. The closest is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 (~460 miles, 7+ hour drive via I-29/I-80). Winter highway conditions on I-80 and I-29 can make travel unreliable from November through March. You must obtain an NPIC appointment before traveling — walk-ins are not accepted."
      disclaimerText="*Processing speed depends on eligibility and documentation. Iowa has no regional passport agency — the closest is Chicago (~460 miles via I-80). Not all applicants qualify for Regional Agency Processing."
    />
  );
}